import { render } from "./FpuiDashboardingLayout.vue?vue&type=template&id=2b126cdf&lang=pug"
import script from "./FpuiDashboardingLayout.vue?vue&type=script&lang=js"
export * from "./FpuiDashboardingLayout.vue?vue&type=script&lang=js"

import "./FpuiDashboardingLayout.vue?vue&type=style&index=0&id=2b126cdf&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__